export interface IUsersFilter {
  orderBy: string;
  ascend: string;
  itemsByPage: number;
  pageIndex: number;
}

export interface ILocations {
  id: number;
  description: string;
}

export interface IEditUser {
  id: number;
  active: boolean;
  name: string;
  email: string;
  role: string;
  jobTitle: string;
  locationDescription: string;
  locations: ILocations[];
  allowMultipleLocations: boolean;
  language: string;
}

export interface IRolesData {
  id: number;
  description: string;
}

export type IItems = {
  id: number;
  active: boolean;
  email: string;
  jobTitle: string;
  locationDescription: string;
  name: string;
  role: string;
};

export interface IUsersState {
  isLoading: boolean;
  isLoadingTable: boolean;
  items?: Array<IItems>;
  totalItems: number;
  filter: IUsersFilter;
  searchFilter: string;
  editUser: IEditUser[];
  rolesList: Array<IRolesData>;
  editActive: boolean;
  formViewOrEditModified: boolean;
}

export const rolesData = [
  {
    id: null,
    description: "",
  },
];

const rolesState = rolesData;

export const defaultState: IUsersState = {
  isLoading: false,
  isLoadingTable: false,
  items: [],
  totalItems: 0,
  searchFilter: "",
  editUser: [],
  rolesList: rolesState,
  editActive: false,
  formViewOrEditModified: false,
  filter: {
    orderBy: "",
    ascend: "",
    itemsByPage: 10,
    pageIndex: 1,
  },
};
